import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { TourSlideOver } from './types';

type TourUiBridgeValue = {
  openSlideOver: TourSlideOver;
  setOpenSlideOver: (v: TourSlideOver) => void;
  clearSlideOver: () => void;
};

const TourUiBridgeContext = createContext<TourUiBridgeValue | null>(null);

export const TourUiBridgeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [openSlideOver, setOpenSlideOver] = useState<TourSlideOver>(null);
  const clearSlideOver = useCallback(() => setOpenSlideOver(null), []);
  const value = useMemo(
    () => ({ openSlideOver, setOpenSlideOver, clearSlideOver }),
    [openSlideOver, clearSlideOver]
  );
  return <TourUiBridgeContext.Provider value={value}>{children}</TourUiBridgeContext.Provider>;
};

export function useTourUiBridge(): TourUiBridgeValue {
  const ctx = useContext(TourUiBridgeContext);
  if (!ctx) {
    return {
      openSlideOver: null,
      setOpenSlideOver: () => {},
      clearSlideOver: () => {},
    };
  }
  return ctx;
}
